import type { Project } from '../projects.type'

/**
 * Picks the project for a workspace, preferring lastUsedProjectId when it is still valid.
 */
export function resolveProjectForWorkspace(
  projects: Project[],
  workspaceId: string,
  lastUsedProjectId?: string | null
): Project | null {
  const workspaceProjects = projects.filter((project) => project.workspaceId === workspaceId)
  if (workspaceProjects.length === 0) {
    return null
  }

  if (lastUsedProjectId) {
    const lastUsed = workspaceProjects.find((project) => project.projectId === lastUsedProjectId)
    if (lastUsed) {
      return lastUsed
    }
  }

  return workspaceProjects[0] ?? null
}
